import '../../../App.css';
import './Sculc-2022.css';

const Sculc2022Program = () => {

    return (
        <div className="sculc2022-page">
            <div className="sculc2022-header-container">
                <img
                    src="/images/new-sculc-header.png"
                    alt="Header"
                    className="sculc2022-header-image"
                />  
                <h1 className="sculc2022-title">Programs</h1>
            </div>
            <div className="sculc2022-navbar">
                <div className="sculc2022-navbar-container">
                    <a href="/sculc-2022" className="sculc2022-links">Home</a>
                    <a href="/sculc-2022-program" className="sculc2022-links">Programs</a>
                    <a href="/sculc-2022-presentation" className="sculc2022-links">Presentations</a>
                    <a href="/sculc-2022-photo" className="sculc2022-links">Photos</a>
                </div>
            </div>
            <div className="sculc2022-banner">
                <p style={{ fontSize: "2em" }}>SCULC 2022 Program</p>
            </div>
            <div className="sculc2022-program-container">
                <iframe src="https://drive.google.com/file/d/1EhXjvQXfydjqlKbcGY_Tvl0KswaebNVZ/preview" width="100%" allow="autoplay" title="program-pdf" style={{ aspectRatio: "8/12" }}></iframe>  
            </div>
            <div style={{height: "5vh"} }></div>
            
                
        </div>
    );
};

export default Sculc2022Program;
